import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email", "button", "note"]

  async submit(event) {
    event.preventDefault()
    
    const formData = new FormData(this.element)
    const originalButtonText = this.buttonTarget.textContent
    
    // Disable form while submitting
    this.buttonTarget.disabled = true
    this.emailTarget.disabled = true
    this.buttonTarget.textContent = "Adding..."
    
    try {
      const response = await fetch('/waitlist', {
        method: 'POST',
        body: formData,
        headers: {
          'Accept': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content || ''
        }
      })
      
      const data = await response.json()
      
      if (data.success) {
        this.buttonTarget.textContent = "Added ✔"
        if (this.hasNoteTarget) {
          this.noteTarget.textContent = data.message
          this.noteTarget.classList.remove('text-red-400')
          this.noteTarget.classList.add('text-white/60')
        }
      } else {
        this.buttonTarget.disabled = false
        this.emailTarget.disabled = false
        this.buttonTarget.textContent = originalButtonText
        if (this.hasNoteTarget) {
          this.noteTarget.textContent = data.message
          this.noteTarget.classList.remove('text-white/60')
          this.noteTarget.classList.add('text-red-400')
        }
      }
    } catch (error) {
      this.buttonTarget.disabled = false
      this.emailTarget.disabled = false
      this.buttonTarget.textContent = originalButtonText
      if (this.hasNoteTarget) {
        this.noteTarget.textContent = "Something went wrong. Please try again."
        this.noteTarget.classList.remove('text-white/60')
        this.noteTarget.classList.add('text-red-400')
      }
    }
  }
}
